import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useScreenLogging } from '../../hooks/useScreenLogging';
import loggingService from '../../services/loggingService';
import { typography } from '../../styles/typography';
import { getAllSites } from '../ShiftManagement/ShiftShedule_Api_service';
import { Card } from '../ui';
import {
  getLaborForecast
  // applyRecommendedStaffing, // ⚠️ COMMENTED OUT - Endpoint not implemented
  // exportStaffingPlan, // ⚠️ COMMENTED OUT - Endpoint not implemented
  // getStaffingRecommendations // ⚠️ COMMENTED OUT - Endpoint not implemented
} from './laborForecastApi';

const INTERVAL_MINUTES = 15;
const HOURS_PER_DAY = 24;
const SLOTS_PER_DAY = (HOURS_PER_DAY * 60) / INTERVAL_MINUTES;

function formatTimeSlot(index) {
  const minutes = index * INTERVAL_MINUTES;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

// function getDummyForecastIntervals(dateStr = null) {
//   const date = dateStr || new Date().toISOString().split('T')[0];
//   return [
//     {
//       forecast_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
//       tenant_id: 'tenant-123',
//       site_id: 'site-456',
//       interval_start: `${date}T06:00:00.000000+00:00`,
//       interval_ts: '06:00',
//       interval_index: 0,
//       predicted_covers: 45,
//       required_headcount: 3,
//       planned_headcount: 3,
//       variance: 0,
//       labor_cost_to_revenue_ratio: 0.28,
//       created_at: `${date}T22:00:00.000000+00:00`,
//     },
//     {
//       forecast_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
//       tenant_id: 'tenant-123',
//       site_id: 'site-456',
//       interval_start: `${date}T09:00:00.000000+00:00`,
//       interval_ts: '09:00',
//       interval_index: 1,
//       predicted_covers: 85,
//       required_headcount: 6,
//       planned_headcount: 5,
//       variance: -1,
//       labor_cost_to_revenue_ratio: 0.26,
//       created_at: `${date}T22:00:00.000000+00:00`,
//     },
//     {
//       forecast_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
//       tenant_id: 'tenant-123',
//       site_id: 'site-456',
//       interval_start: `${date}T12:00:00.000000+00:00`,
//       interval_ts: '12:00',
//       interval_index: 2,
//       predicted_covers: 120,
//       required_headcount: 8,
//       planned_headcount: 8,
//       variance: 0,
//       labor_cost_to_revenue_ratio: 0.25,
//       created_at: `${date}T22:00:00.000000+00:00`,
//     },
//     {
//       forecast_id: 'd4e5f6a7-b8c9-0123-def0-234567890123',
//       tenant_id: 'tenant-123',
//       site_id: 'site-456',
//       interval_start: `${date}T15:00:00.000000+00:00`,
//       interval_ts: '15:00',
//       interval_index: 3,
//       predicted_covers: 95,
//       required_headcount: 6,
//       planned_headcount: 7,
//       variance: 1,
//       labor_cost_to_revenue_ratio: 0.27,
//       created_at: `${date}T22:00:00.000000+00:00`,
//     },
//     {
//       forecast_id: 'e5f6a7b8-c9d0-1234-ef01-345678901234',
//       tenant_id: 'tenant-123',
//       site_id: 'site-456',
//       interval_start: `${date}T18:00:00.000000+00:00`,
//       interval_ts: '18:00',
//       interval_index: 4,
//       predicted_covers: 180,
//       required_headcount: 12,
//       planned_headcount: 11,
//       variance: -1,
//       labor_cost_to_revenue_ratio: 0.22,
//       created_at: `${date}T22:00:00.000000+00:00`,
//     },
//     {
//       forecast_id: 'f6a7b8c9-d0e1-2345-f012-456789012345',
//       tenant_id: 'tenant-123',
//       site_id: 'site-456',
//       interval_start: `${date}T21:00:00.000000+00:00`,
//       interval_ts: '21:00',
//       interval_index: 5,
//       predicted_covers: 140,
//       required_headcount: 9,
//       planned_headcount: 9,
//       variance: 0,
//       labor_cost_to_revenue_ratio: 0.24,
//       created_at: `${date}T22:00:00.000000+00:00`,
//     },
//   ];
// }

/** Color intensity 0–1 from value and max. */
function intensity(value, max) {
  if (max <= 0) return 0;
  return Math.min(1, Math.max(0, value / max));
}

/** Label for intensity (for display). */
function intensityLabel(alpha) {
  if (alpha <= 0.4) return 'Low';
  if (alpha <= 0.7) return 'Medium';
  return 'High';
}

/** Staffing state from variance. */
function staffingState(variance) {
  if (variance < 0) return 'Understaffed';
  if (variance > 0) return 'Overstaffed';
  return 'OK';
}

export default function LaborForecastHeatmap() {
  // Log screen view
  useScreenLogging('LaborForecastHeatmap', {
    component: 'LaborForecastHeatmap',
    screenType: 'labor-forecast',
  });

  const [searchParams] = useSearchParams();
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const fromUrl = searchParams.get('date');
    if (fromUrl) return fromUrl;
    const d = new Date();
    return d.toISOString().split('T')[0];
  });
  const [targetLaborRatio, setTargetLaborRatio] = useState('');
  const [intervals, setIntervals] = useState([]); // was: buildMockIntervals('All')
  const [hoverCell, setHoverCell] = useState(null);
  const [actionLoading, setActionLoading] = useState(null);
  const [actionMessage, setActionMessage] = useState(null);
  const [loadingForecast, setLoadingForecast] = useState(false);

  const loadSites = useCallback(async () => {
    try {
      const data = await getAllSites();
      const list = Array.isArray(data) ? data : (data?.sites || data?.data || []);
      // Sort sites alphabetically by site name
      const sortedSites = [...list].sort((a, b) => {
        const nameA = (a?.site_name || a?.name || '').toLowerCase();
        const nameB = (b?.site_name || b?.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
      setSites(sortedSites);
      // Only auto-select if siteId is in URL params, otherwise let user select
      const siteIdFromUrl = searchParams.get('siteId');
      if (siteIdFromUrl && sortedSites.length > 0) {
        const site = sortedSites.find(s => s.site_id === siteIdFromUrl);
        if (site) setSelectedSite(site);
        // Don't auto-select if site from URL not found - let user select
      }
      // Don't auto-select first site - let user select from dropdown
    } catch (e) {
      console.error('Failed to load sites:', e);
      setSites([]);
    }
  }, [searchParams]);

  useEffect(() => {
    loadSites();
  }, [loadSites]);

  const loadForecast = useCallback(async () => {
    if (!selectedSite?.site_id || !selectedDate) {
      // Fallback to mock data if no site/date selected
      // setIntervals(buildMockIntervals(roleGroup));
      setIntervals([]);
      return;
    }

    setLoadingForecast(true);
    setActionMessage(null);
    try {
      const opts = {};
      const ratio = targetLaborRatio === '' || targetLaborRatio == null ? null : Number(targetLaborRatio);
      if (ratio != null && !isNaN(ratio)) opts.targetLaborRatio = ratio;
      const result = await getLaborForecast(selectedSite.site_id, selectedDate, opts);
      
      // Log API event for viewing labor forecast
      loggingService.logInfo(
        'labor_forecast_view',
        `User viewed labor forecast for site ${selectedSite.site_id} on date ${selectedDate}`,
        {
          endpoint: '/labor/forecast',
          method: 'GET',
          siteId: selectedSite.site_id,
          date: selectedDate,
          targetLaborRatio: opts.targetLaborRatio || null,
          intervalCount: result?.intervals?.length || 0,
        }
      ).catch(logError => {
        console.warn('[LaborForecastHeatmap] Failed to log event:', logError);
      });
      
      if (result?.intervals && result.intervals.length > 0) {
        setIntervals(result.intervals);
      } else {
        // Fallback to mock data if no forecasts found
        // setIntervals(buildMockIntervals(roleGroup));
        setIntervals([]);
      }
    } catch (error) {
      console.error('Failed to load forecast:', error);
      setActionMessage(`Failed to load forecast: ${error.message}`);
      // Fallback to mock data on error
      // setIntervals(buildMockIntervals(roleGroup));
      setIntervals([]);
    } finally {
      setLoadingForecast(false);
    }
  }, [selectedSite, selectedDate, targetLaborRatio]);

  useEffect(() => {
    loadForecast();
  }, [loadForecast]);

  /**
   * ⚠️ COMMENTED OUT - API endpoints not implemented in backend
   * Handle apply recommended staffing action
   */
  // const handleApplyRecommended = async () => {
  //   if (!selectedSite?.site_id) return;
  //   setActionLoading('apply');
  //   setActionMessage(null);
  //   try {
  //     const rec = await getStaffingRecommendations(selectedSite.site_id, selectedDate, {});
  //     await applyRecommendedStaffing(selectedSite.site_id, selectedDate, rec?.recommendations || rec || []);
  //     setActionMessage('Recommended staffing applied successfully.');
  //   } catch (e) {
  //     setActionMessage(`Error: ${e.message}`);
  //   } finally {
  //     setActionLoading(null);
  //   }
  // };

  /**
   * ⚠️ COMMENTED OUT - API endpoint not implemented in backend
   * Handle export staffing plan action
   */
  // const handleExport = async () => {
  //   if (!selectedSite?.site_id) return;
  //   setActionLoading('export');
  //   setActionMessage(null);
  //   try {
  //     await exportStaffingPlan(selectedSite.site_id, selectedDate, 'csv');
  //     setActionMessage('Staffing plan exported.');
  //   } catch (e) {
  //     setActionMessage(`Export failed: ${e.message}`);
  //   } finally {
  //     setActionLoading(null);
  //   }
  // };

  const maxHeadcount = Math.max(1, ...intervals.map(i => i.required_headcount ?? 0));

  return (
    <div className="max-w-full">
      <h2 className={typography.h3} style={{ color: '#000', marginBottom: '1rem' }}>
        Labor Forecast Heatmap
      </h2>

      {/* Filters */}
      <Card.Light className="p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Site</label>
            <select
              className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-white"
              value={selectedSite?.site_id ?? ''}
              onChange={e => setSelectedSite(sites.find(s => s.site_id === e.target.value) || null)}
            >
              <option value="">Select a site</option>
              {/* Sites are already sorted alphabetically when fetched */}
              {Array.isArray(sites) && sites.map((site) => (
                <option key={site.site_id || site.id} value={site.site_id || site.id}>
                  {site.site_name || site.name || 'Unknown Site'}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
              value={selectedDate}
              onChange={e => setSelectedDate(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Target labor cost ratio (optional)</label>
            <input
              type="number"
              min={0}
              max={1}
              step={0.01}
              placeholder="e.g. 0.28"
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
              value={targetLaborRatio}
              onChange={e => setTargetLaborRatio(e.target.value)}
            />
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={loadForecast}
              disabled={loadingForecast || !selectedSite?.site_id}
            >
              {loadingForecast ? 'Loading...' : 'Refresh'}
            </button>
          </div>
        </div>
      </Card.Light>

      {/* Action bar */}
      {/* <div className="flex flex-wrap items-center gap-3 mb-4">
        <PrimaryButton
          onClick={handleApplyRecommended}
          disabled={!selectedSite?.site_id || actionLoading === 'apply'}
        >
          {actionLoading === 'apply' ? 'Applying…' : 'Apply recommended staffing'}
        </PrimaryButton>
        <PrimaryButton
          onClick={handleExport}
          disabled={!selectedSite?.site_id || actionLoading === 'export'}
          className="bg-emerald-600 hover:bg-emerald-700"
        >
          {actionLoading === 'export' ? 'Exporting…' : 'Export staffing plan'}
        </PrimaryButton>
        {actionMessage && (
          <span className="text-sm text-gray-600">{actionMessage}</span>
        )}
      </div> */}

      {actionMessage && (
        <p className={typography.p} style={{ color: '#b45309', marginTop: '0.5rem', fontSize: '0.875rem' }}>
          {actionMessage}
        </p>
      )}

      <p className={typography.p} style={{ color: '#666', marginTop: '1rem', fontSize: '0.875rem' }}>
        Color = staffing intensity (Low/Medium/High). State = Understaffed / Overstaffed / OK. ▼ Understaffed, ▲ Overstaffed. Hover a cell for details.
      </p>

      {/* Heatmap grid: API forecasts as rows */}
      <div className="relative">
        <Card.Light className="p-4 overflow-x-auto">
          {loadingForecast ? (
            <div className="py-8 text-center text-gray-500">Loading forecasts…</div>
          ) : intervals.length === 0 ? (
            <div className="py-8 text-center text-gray-500">
              {selectedSite?.site_id && selectedDate
                ? 'No forecasts for this site and date.'
                : 'Select a site and date, then click Refresh.'}
            </div>
          ) : (
          <div className="min-w-full">
            <div className="gap-px bg-gray-200 rounded-lg overflow-hidden" style={{ display: 'grid', gridTemplateColumns: '80px 1fr 90px 110px' }}>
              <div className="bg-gray-100 p-2 font-medium text-gray-700 text-sm">Time</div>
              <div className="bg-gray-100 p-2 font-medium text-gray-700 text-sm">Staffing need (color)</div>
              <div className="bg-gray-100 p-2 font-medium text-gray-700 text-sm">Color</div>
              <div className="bg-gray-100 p-2 font-medium text-gray-700 text-sm">State</div>
              {intervals.map((row, idx) => {
                const req = row.required_headcount ?? 0;
                const planned = row.planned_headcount ?? row.required_headcount ?? 0;
                const variance = row.variance ?? (planned - req);
                const isUnder = variance < 0;
                const isOver = variance > 0;
                const alpha = 0.2 + 0.8 * intensity(req, maxHeadcount);
                const colorLabel = intensityLabel(alpha);
                const stateLabel = staffingState(variance);
                const isHovered = hoverCell && (hoverCell.interval_index ?? -1) === idx;
                return (
                  <div key={row.forecast_id ?? row.interval_ts ?? idx} className="contents">
                    <div className="bg-gray-50 p-1.5 text-xs text-gray-600 flex items-center">
                      {row.interval_ts ?? formatTimeSlot(idx)}
                    </div>
                    <div
                      className="relative p-1.5 flex items-center justify-center min-h-[28px] cursor-default"
                      style={{ backgroundColor: `rgba(34, 139, 34, ${alpha})` }}
                      onMouseEnter={() => setHoverCell({ ...row, interval_index: row.interval_index ?? idx })}
                      onMouseLeave={() => setHoverCell(null)}
                    >
                      {isHovered && (
                        <div
                          className="absolute left-0 right-0 bottom-full z-10 mb-1 p-3 bg-white text-black text-sm rounded-lg shadow-lg pointer-events-none"
                          style={{ minWidth: '200px' }}
                        >
                          <div className="font-medium mb-1">Interval: {row.interval_ts ?? formatTimeSlot(idx)}</div>
                          <div>Predicted covers: {row.predicted_covers ?? '—'}</div>
                          <div>Required headcount: {row.required_headcount ?? '—'}</div>
                          {row.labor_cost_to_revenue_ratio != null && (
                            <div>Labor cost ratio: {(Number(row.labor_cost_to_revenue_ratio) * 100).toFixed(1)}%</div>
                          )}
                          <div>Variance: {row.variance != null ? (row.variance > 0 ? '+' : '') + row.variance : '—'}</div>
                        </div>
                      )}
                      <span className="text-xs font-medium text-white drop-shadow" style={{ opacity: alpha > 0.5 ? 1 : 0.9 }}>
                        {req}
                      </span>
                      {isUnder && (
                        <span className="absolute right-1 top-1/2 -translate-y-1/2 text-red-600" title="Understaffed">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M7 14l5-5 5 5z"/></svg>
                        </span>
                      )}
                      {isOver && !isUnder && (
                        <span className="absolute right-1 top-1/2 -translate-y-1/2 text-amber-600" title="Overstaffed">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>
                        </span>
                      )}
                    </div>
                    <div className="bg-gray-50 p-1.5 text-xs text-gray-700 flex items-center">
                      {colorLabel}
                    </div>
                    <div className={`p-1.5 text-xs font-medium flex items-center ${isUnder ? 'text-red-600' : isOver ? 'text-amber-600' : 'text-green-700'}`}>
                      {stateLabel}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          )}
        </Card.Light>
      </div>

      
    </div>
  );
}
